import { Locale } from 'date-fns';

export interface DateRange {
  from?: Date;
  to?: Date;
  presetLabel?: string;
  presetValue?: string;
  default?: boolean;
}

export interface DateValue {
  range: DateRange;
  comparison?: DateRange;
}

export interface PresetOption {
  value: string;
  label: string;
  description?: string;
  from?: Date;
  to?: Date;
  containsInvalidDates?: boolean;
}

export type CalendarGranularity = 'daily' | 'weekly' | 'monthly';

export interface GranularityToggleOption {
  value: CalendarGranularity;
  labelId: string;
}

export interface GranularityToggleConfig {
  options: GranularityToggleOption[];
  onChange: (granularity: CalendarGranularity) => void;
  disabled?: boolean;
}

export const WEEKLY_START_DAY_OPTIONS = {
  weekStartsOn: 1,
} as {
  locale?: Locale;
  weekStartsOn?: 0 | 1 | 2 | 3 | 4 | 5 | 6;
};
